<template>
    <div class="upload_doc">
		<el-dialog @opened="dialogOpen" center :visible.sync="uploadVisible" width="780px" :close-on-click-modal="false" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">上传文档</div>
				<div class="close_btn" @click="uploadVisible = false"><img class="close_icon" src="../views/img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content">
                <div class="drag_zone" id="dragDrop">
                    <img v-if="upoadLoading" class="ipload_icon" src="./img/loading.gif" alt="">
                    <img v-else class="ipload_icon" src="./img/img_icon_01.png" alt="">
                    <div class="upload_desc">点击上传或文档拖拽到此处<br/>文档不要超过15M，仅支持Docx格式</div>
                    <input class="upload_file_input" ref="fileInput" accept=".docx" type="file" @change="inputUpload" title="">
                </div>
                <div class="upload_tips">注：上传文档默认选择短文写作！若需要指定，请选择应用后点击右上角上传文档！</div>
            </div>
		</el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                uploadVisible:false,
                dropBox:null,
                upoadLoading:false
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.uploadVisible = true;
            },
            close(){
                this.uploadVisible = false;
            },
            dialogOpen(){
                if(!this.dropBox){
                    this.dropBox = document.querySelector('#dragDrop');
                    // 源对象落在目标对象上
                    this.dropBox.addEventListener('drop', this.drop, false);
                }
            },
            drop(e){
                e.preventDefault();
                // 当文件拖拽到dropBox区域时,可以在该事件取到file
                this.dealFiles(e.dataTransfer.files);
            },
            inputUpload(e){
                this.dealFiles(e.target.files);
                this.$refs.fileInput.value = "";
            },
            dealFiles(files){
                if(files.length > 1){
                    this.$message({
                        message: '仅支持单个文件上传',
                        type: 'warning'
                    })
                    return
                }
                let file = files[0];
                if(file.type != "application/msword" && file.type != "application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
                    this.$message({
                        message: '仅支持word文档',
                        type: 'warning'
                    })
                    return
                }
                if(file.size > 15*1024*1024){
                    this.$message({
                        message: '请上传15M以内的图片',
                        type: 'warning'
                    })
                    return
                }
                this.uploadFile(file)
            },
            async uploadFile(file){
                this.upoadLoading = true
                this.uploadError = ""
                let post_url = await this.$http.get(`/front/upload/doc/?file_folder=docfile`).then(res => {
                    return res.data
                }).catch(e => {
                    return ""
                });
                if (!post_url) {
                    this.$message({
                        message: '很抱歉，系统出错，请重新上传！',
                        type: 'warning'
                    })
                    return
                }
                // 上传图片
                let formData = new FormData();
                formData.append("file", file, file.name);
                let fileResponse = await this.$http.post(post_url, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    responseType: "text"
                }).then(res => {
                    return eval(res);
                }).catch(e => {
                    return "";
                });
                let res = fileResponse.data
                this.upoadLoading = false
                this.$emit("uploaded",res);
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .dialog_title{
        border-bottom: none!important;
    }
    .dialog_content{
        padding: 0 32px;
        .drag_zone{
            height: 302px;
            border: 2px dashed #d4d4d5;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f6f7f8;
            flex-direction: column;
            position: relative;
            .ipload_icon{
                width: 30px;
                height: 30px;
                display: block;
            }
            .upload_desc{
                margin-top: 21px;
                line-height: 34px;
                font-size: 12px;
                color: #999;
                text-align: center;
            }
            .upload_file_input{
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                z-index: 1;
                top: 0;
                left: 0;
                cursor: pointer;
            }
        }
        .upload_tips{
            font-size: 12px;
            color: #999;
            line-height: 90px;
        }
    }
</style>